import { Component, OnInit } from '@angular/core';
import 'rxjs/Rx';
import { Subscription } from 'rxjs/Rx';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { forgotPasswordService } from '../../_services/userservice/user.forgotpassword.service'; //For accessing user mail
import { resetPasswordService } from '../../_services/userservice/user.resetchangepassword.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import * as moment from 'moment';
import { AuthService } from "../../_services/userservice/auth.service";
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import {
    UserProfileTMNIovation,
    enumEventype
} from "../../models/user/user.tm.profile.model";

export class resetModalContext extends BSModalContext { }
@Component({
    moduleId: module.id,
    providers: [resetPasswordService, forgotPasswordService, AlertService, utilityService],
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements ModalComponent<resetModalContext> {
    context: resetModalContext;
    public isDOBflag;
    public isTransflag;
    isTextdispaly = true;
    appSettings: any;
    model: any = {};
    loading = false;
    yearRange = '';
    public defaultDate: any;
    userProfileTMNIovation: UserProfileTMNIovation;
    fraudBusy: Subscription;
    private _newPassword: string = '';
    private fraudService: Promise<void>;

    get NewPassword(): string {
        return this._newPassword;
    }

    set NewPassword(value: string) {
        this._newPassword = value;
    }

    constructor(
        public dialog: DialogRef<resetModalContext>,
        private rstPassword: resetPasswordService,
        private fgttPassword: forgotPasswordService,
        private userCommon: usercommonattribute,
        private alertService: AlertService,
        private auth: AuthService,
        public utilServ: utilityService,
        private translate: TranslateService
    ) {
        this.context = dialog.context;
    }

    ngOnInit() {
        this.appSettings = AppSettings;
        this.isDOBflag = this.userCommon.dobflag;
        this.isTransflag = this.userCommon.tranflag;
        this.yearRange = new Date().getFullYear() - 100 + ':' + (new Date().getFullYear() - 18);
        this.defaultDate = new Date(
            moment()
                .subtract(100, 'years')
                .format('MM/DD/YYYY')
        ); //

        this.fraudService = new Promise((resolve, reject) => {

                this.userProfileTMNIovation = new UserProfileTMNIovation();
                this.userProfileTMNIovation.deviceProfile.SessionID = localStorage.sessionId;
                this.userProfileTMNIovation.deviceProfile.IovationBlackBoxKey = sessionStorage.iovationBBKey;
                this.userProfileTMNIovation.eventType = enumEventype[enumEventype.Device_Profile];

                this.fraudBusy = this.auth.profileTMnIovation(this.userProfileTMNIovation).subscribe(data => {

                    let resJSON = data;

                    if (resJSON.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {
                        sessionStorage.publicKeyRSA = resJSON.Envelope.Body.FraudDetectionResponse.RSAPublicKey;
                        sessionStorage.KeyUID = resJSON.Envelope.Body.FraudDetectionResponse.KeyUID;
                        this.userCommon.KeyUID = resJSON.Envelope.Body.FraudDetectionResponse.KeyUID;

                        resolve();

                    } else {
                        reject();
                    }
                });
        });
    }

    resetPasswordClick() {

        let self = this;

        self.fraudService.then(() => {

            self.isTextdispaly = false;
            self.model.Password = self._newPassword;
            self.model.CustomerEmail = self.userCommon.email;
            self.model.KeyUID = sessionStorage.KeyUID;
            self.model.UserID = self.userCommon.UserID;
            self.model.DOB = self.isDOBflag == 'true' ? moment(self.model.DOB).format('L') : '';
            // Call Change Password
            self.utilServ.busy = self.rstPassword.resetPassword(self.model).subscribe(
                data => {
                    const resJSON = data;
                    if (resJSON.Envelope.Body.ResetPasswordResponse.StatusCode == 20001) {
                        return false;
                    } else if (resJSON.Envelope.Body.ResetPasswordResponse.StatusCode == -10000) {
                      self.alertService.openErrorAlert(self.translate.instant('Common_lblOops'), self.translate.instant('Message_errorMessage'));
                        return;
                    } else if (resJSON.Envelope.Body.ResetPasswordResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                        // this.alertService.success(resJSON.Envelope.Body.ResetPasswordResponse.StatusMessage);
                        self.alertService.openErrorAlert(self.translate.instant('Common_lblInfo'), self.translate.instant('Message_lblPasswordUpdatedSuccessfully'));
                        self.closePopup();
                    } else {
                        //  this.alertService.error(resJSON.Envelope.Body.ResetPasswordResponse.StatusMessage);
                        self.alertService.openErrorAlert(self.translate.instant('Common_lblOops'), resJSON.Envelope.Body.ResetPasswordResponse.StatusMessage);
                        console.log(resJSON.Envelope.Body.ResetPasswordResponse.StatusMessage);
                    }
                },
                err => console.log(err),
                () => console.log('Completed')
            );
        }, () => {
          self.alertService.openErrorAlert(self.translate.instant('Common_lblOops'), self.translate.instant('Message_errorMessage'));
        });

        self.loading = true;

    }

    closePopup() {
        this.dialog.close();
    }

    LengthPolicy(): boolean {
        return this._newPassword.length >= 8 && this._newPassword.length <= 15;
    }

    OneUppercaseLetterPolicy(): boolean {
        return /[A-Z]+?/.test(this._newPassword);
    }

    OneLowercaseLetterPolicy(): boolean {
        return /[a-z]+?/.test(this._newPassword);
    }

    OneDigitPolicy(): boolean {
        return /[0-9]+?/.test(this._newPassword);
    }

    OneSpecialCharPolicy(): boolean {
        return (new RegExp(this.appSettings.passwordSpecialCharPattern)).test(this._newPassword);
    }
}



// WEBPACK FOOTER //
// ./src/app/user/reset-password/reset-password.component.ts